import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-darts-cs',
    templateUrl: './default/darts-cs9/darts-cs.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class DartsCorrectScoreComponent extends UnitsDistributionBase {
  // Used for DARTS_CORRECT_SCORE_9
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}